import { useRef, useState } from 'react';

import { useGenericModal } from '..';
import { ConfirmDeleteModal } from './confirm-delete-modal';

/**
 * Awaitable delete confirmation, same shape as `useFileConflictModal`:
 * `if (!(await confirm(name))) return;`
 */
export const useConfirmDeleteModal = () => {
  const { modalRef, openModal, closeModal } = useGenericModal();
  const [target, setTarget] = useState('');
  const resolveRef = useRef<((proceed: boolean) => void) | null>(null);

  const settle = (proceed: boolean) => {
    resolveRef.current?.(proceed);
    resolveRef.current = null;
    closeModal();
  };

  const confirm = (name: string): Promise<boolean> => {
    setTarget(name);
    openModal();
    return new Promise<boolean>((resolve) => {
      resolveRef.current = resolve;
    });
  };

  const confirmDeleteModal = (
    <ConfirmDeleteModal
      modalRef={modalRef}
      target={target}
      onCancel={() => settle(false)}
      onConfirm={() => settle(true)}
    />
  );

  return { confirm, confirmDeleteModal };
};
